export default "__VITE_ASSET__519170b2__"